import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import BusinessUnitService from '../domain/businessUnit/BusinessUnitService';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/unidade/:name',
    name: 'BusinessUnit',
    component: () => import('../views/BusinessUnitView.vue'),
  },
  {
    path: '/summary',
    name: 'Summary',
    component: () => import('../views/AllCompaniesView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    const names = await BusinessUnitService.getBusinessUnitNames();
    const first = names[0] || '';
    next(`/unidade/${first}`);
    return;
  }
  next();
});

export default router;
